(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-product"] && !Shopify.designMode) return;
  try {
    
const uploadZone = document.querySelector('[data-upload-zone]')
const fileInput = document.querySelector('[data-file-input]')
const previewContainer = document.querySelector('[data-preview-container]')
const uploadedPreviews = new Map()

// Drag and drop support
uploadZone.addEventListener('dragover', e => {
  e.preventDefault()
  uploadZone.style.borderColor = '#B8A997'
})

uploadZone.addEventListener('dragleave', () => {
  uploadZone.style.borderColor = '#D4CBC0'
})

uploadZone.addEventListener('drop', e => {
  e.preventDefault()
  uploadZone.style.borderColor = '#D4CBC0'
  processFiles(e.dataTransfer.files)
})

// Process uploaded files with validation
fileInput.addEventListener('change', e => processFiles(e.target.files))

function processFiles(files) {
  Array.from(files).forEach((file, index) => {
    // Native file validation
    if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
      alert('Only JPG and PNG files are allowed.')
      return
    }
    if (file.size > 10 * 1024 * 1024) {
      alert(`${file.name} is larger than 10MB, please use a smaller file.`)
      return
    }

    // Create live image preview
    const previewWrapper = document.createElement('div')
    previewWrapper.className = 'hawta-preview-item'
    
    const img = document.createElement('img')
    img.src = URL.createObjectURL(file)
    img.style.width = '100%'
    img.style.height = '100%'
    
    const removeBtn = document.createElement('button')
    removeBtn.innerText = '×'
    removeBtn.addEventListener('click', () => {
      previewWrapper.remove()
      // Remove file from input selection
      const dt = new DataTransfer()
      const currentFiles = Array.from(fileInput.files).filter(f => f !== file)
      currentFiles.forEach(f => dt.items.add(f))
      fileInput.files = dt.files
      uploadedPreviews.delete(previewWrapper)
    })

    previewWrapper.append(img, removeBtn)
    previewContainer.appendChild(previewWrapper)
    uploadedPreviews.set(previewWrapper, file)
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
